"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usdmPositionUpdateToPosition = exports.usdmAccountEventsToPositions = exports.futuresUsdmOrderUpdateToFuturesUsdmOrderMapper = exports.futuresUsdmOrderUpdateRawToOrderUpdateMapper = void 0;
const shared_1 = require("../data/shared");
const misc_1 = require("../misc");
const futures_1 = require("./futures");
const futuresUsdmOrderUpdateRawToOrderUpdateMapper = (order) => {
    return {
        eventType: order.e,
        eventTime: order.E,
        symbold: order.o.s,
        clientOrderId: order.o.c,
        orderId: order.o.i,
        side: order.o.S,
        type: order.o.o,
        origQty: order.o.q,
        price: order.o.p,
        stopPrice: order.o.sp,
        cumulativeFilledQty: order.o.z,
        status: order.o.X,
        time: order.o.T,
        activatePrice: order.o.AP
    };
};
exports.futuresUsdmOrderUpdateRawToOrderUpdateMapper = futuresUsdmOrderUpdateRawToOrderUpdateMapper;
const futuresUsdmOrderUpdateToFuturesUsdmOrderMapper = (orderUpdate) => {
    return {
        symbol: orderUpdate.symbold,
        orderId: orderUpdate.orderId,
        price: orderUpdate.price,
        origQty: orderUpdate.origQty,
        executedQty: orderUpdate.cumulativeFilledQty,
        status: orderUpdate.status,
        type: orderUpdate.type,
        side: orderUpdate.side,
        updateTime: orderUpdate.eventTime,
        time: orderUpdate.time,
        activatePrice: orderUpdate.activatePrice,
        stopPrice: orderUpdate.stopPrice,
        priceOutput: (0, futures_1.getFuturesOrderPrice)({
            type: orderUpdate.type,
            price: orderUpdate.price,
            activatePrice: orderUpdate.activatePrice,
            stopPrice: orderUpdate.stopPrice
        })
    };
};
exports.futuresUsdmOrderUpdateToFuturesUsdmOrderMapper = futuresUsdmOrderUpdateToFuturesUsdmOrderMapper;
const usdmAccountEventsToPositions = (params) => {
    const { accountEvents, exchangeInfo, knownPositions } = params;
    return accountEvents.map(accountEvent => {
        return accountEvent.updateData.updatedPositions.map(positionEvent => {
            const eventPositionId = (0, misc_1.createPositionId)({
                side: positionEvent.positionSide,
                symbol: positionEvent.symbol
            });
            const positionKnown = knownPositions.get(eventPositionId);
            return (0, exports.usdmPositionUpdateToPosition)({
                exchangeInfo: exchangeInfo,
                positionEvent: positionEvent,
                updateTime: accountEvent.eventTime,
                liquidationPrice: (positionKnown === null || positionKnown === void 0 ? void 0 : positionKnown.liquidationPrice) || ''
            });
        });
    }).flatMap(positions => positions);
};
exports.usdmAccountEventsToPositions = usdmAccountEventsToPositions;
const usdmPositionUpdateToPosition = (params) => {
    const { positionEvent, liquidationPrice, exchangeInfo, updateTime } = params;
    const symbolInfo = (0, misc_1.filterExchageInfoBySymbol)({
        symbol: positionEvent.symbol,
        exchangeInfo: exchangeInfo
    });
    const positionSideOutput = (0, misc_1.getPositionSideForView)(positionEvent.positionSide, positionEvent.positionAmount);
    return {
        uid: (0, misc_1.createPositionId)({
            side: positionEvent.positionSide,
            symbol: positionEvent.symbol
        }),
        symbol: positionEvent.symbol,
        entryPrice: positionEvent.entryPrice.toString(),
        positionAmt: positionEvent.positionAmount.toString(),
        positionSide: positionEvent.positionSide,
        unrealizedPnl: positionEvent.unrealisedPnl.toString(),
        quoteAsset: (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteAsset) || '',
        baseAsset: (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseAsset) || '',
        updateTime: updateTime,
        liquidationPrice: liquidationPrice,
        positionSideOutput: positionSideOutput,
        marginType: positionEvent.marginType,
        unrealizedPnlPercent: shared_1.FuturesDataUtils.calcUnPnlPercent({
            entryPrice: positionEvent.entryPrice,
            positionAmount: positionEvent.positionAmount,
            unrealisedPnl: positionEvent.unrealisedPnl
        }).toString(),
        adl: 0
    };
};
exports.usdmPositionUpdateToPosition = usdmPositionUpdateToPosition;
